import { gql } from "@apollo/client";

export const CLIP_OF_THE_DAY = gql`
  query ClipOfTheDay {
    clipOfTheDayNew {
      title
      thumbnailUrl(style: OVERLAY)
      url(orientation: LANDSCAPE)
      shareId
      views
      createdAt
      playerGameIdentifier
      user {
        internalId
        avatarUrl
        username
      }
      tags {
        key
        value
      }
    }
  }
`;
